import { generateUniqueId } from '../../helpers/common';

export const FETCH_PERSONAS_REQUEST = generateUniqueId();
export const FETCH_PERSONAS_SUCCESS = generateUniqueId();
export const FETCH_PERSONAS_FAILURE = generateUniqueId();

export const CREATE_PERSONA_REQUEST = generateUniqueId();
export const CREATE_PERSONA_SUCCESS = generateUniqueId();
export const CREATE_PERSONA_FAILURE = generateUniqueId();